var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',_vm._b({attrs:{"value":_vm.value,"label":_vm.label,"name":_vm.name},on:{"change":function($event){return _vm.$emit('input', $event)}}},'v-radio-group',_vm.$attrs,false),_vm._l((_vm.items),function(item){return _c('v-radio',{key:item.id,attrs:{"label":`${item.type} (${_vm.euro(item.value)})`,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }